import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IAppraisal } from "@/models/appraisal.entity";
import appraisalService from "@/services/mrfiktiv/services/appraisal.service";
import { MrfiktivAppraisalControllerFindAllParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const AppraisalPageDataProvider = new (class extends AbstractPageDataProvider<
  IAppraisal,
  MrfiktivAppraisalControllerFindAllParamsGen
> {
  itemsPerPage = 25;

  async getPage(query: MrfiktivAppraisalControllerFindAllParamsGen): Promise<IPageViewModel<IAppraisal>> {
    const res = await appraisalService.get(query);

    const meta = res.meta;
    const data = (res.data ?? []) as IAppraisal[];

    return { meta, data };
  }
})();
